import { createAppAsyncThunk } from "core/src/store/store.types";
import { postToast, ToastType } from "core/src/slices/ui/useCases/postToast/postToast.use-case";
import { displayApiErrorToast } from "core/src/slices/ui/useCases/display-api-error-toast/display-api-error-toast.use-case";
import { apiSlice } from "core/src/store/rtk-instance";
import { TriggerFiltersTagsEnum } from "core/src/slices/formStep/triggerFilters.endpoints";
import axios from "axios";

export type ReuploadCsvRequest = {
  file: File;
  baseClassName: string;
  labId?: string;
};

export const reuploadCsv = createAppAsyncThunk<void, ReuploadCsvRequest>(
  "formStep/reuploadCsv",
  async ({ file, baseClassName, labId }, { getState, extra, dispatch, rejectWithValue }) => {
    try {
      const { selectedEtlImportUuid } = getState().etlData;
      if (!selectedEtlImportUuid) return rejectWithValue("Aucun import sélectionné");

      const formData = new FormData();
      formData.append("file", file);

      await extra.etlClient.reuploadCsv(selectedEtlImportUuid, {
        formData,
        baseClassName,
        labId,
      });

      dispatch(postToast({ type: ToastType.SUCCESS, message: "CSV re-uploadé, prétraitement relancé." }));
      dispatch(apiSlice.util.invalidateTags([{ type: TriggerFiltersTagsEnum.GENERAL, id: selectedEtlImportUuid }]));
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        dispatch(displayApiErrorToast(error.response));
        return rejectWithValue(error.response?.data?.message ?? "Erreur lors du re-upload");
      }
      return rejectWithValue("Erreur lors du re-upload");
    }
  }
);
